<div class="container">
  <div *ngIf="data.isHsoEvaluator === true">
    <mat-form-field appearance="fill">
      <mat-label>Choose Result Type</mat-label>
      <mat-select [(ngModel)]="selectedValue">
        <mat-option value="1" [disabled]="isLabExist(1)">
          Stool Laboratory Result
        </mat-option>
        <mat-option value="2" [disabled]="isLabExist(2)">
          X-ray Laboratory Result
        </mat-option>
        <mat-option value="3" [disabled]="isLabExist(3)">
          Syphilis Screening Test
        </mat-option>
      </mat-select>
    </mat-form-field>
    <ng-container *ngIf="selectedValue == 1">
      <mat-form-field appearance="fill">
        <mat-label>Classification</mat-label>
        <mat-select [(ngModel)]="selectedStoolClassification">
          <mat-option
            [value]="item.id"
            *ngFor="let item of stoolClassifications"
          >
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Color</mat-label>
        <mat-select [(ngModel)]="selectedStoolColors">
          <mat-option [value]="item.id" *ngFor="let item of stoolColors">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Consistency</mat-label>
        <mat-select [(ngModel)]="selectedStoolConsistencies">
          <mat-option [value]="item.id" *ngFor="let item of stoolConsistencies">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Microscopic Examination</mat-label>
        <mat-select [(ngModel)]="selectedStoolMicroscopy">
          <mat-option [value]="item.id" *ngFor="let item of stoolMicroscopy">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Remarks</mat-label>
        <mat-select [(ngModel)]="selectedStoolExamRemarks">
          <mat-option [value]="item.id" *ngFor="let item of stoolExamRemarks">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Method</mat-label>
        <mat-select [(ngModel)]="selectedStoolMethods">
          <mat-option [value]="item.id" *ngFor="let item of stoolMethods">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="selectedValue == 2">
      <!-- <mat-form-field appearance="fill" *ngIf="selectedValue == 2">
      <mat-label>Choose X-Ray Result Type</mat-label>
      <mat-select [(ngModel)]="xrayValue">
        <mat-option [value]="item.id" *ngFor="let item of xrayTypes">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field> -->
      <mat-form-field appearance="fill" *ngIf="selectedValue == 2">
        <mat-label>Impressions</mat-label>
        <mat-select [(ngModel)]="xrayImpression">
          <mat-option [value]="1">Essentially Normal Chest</mat-option>
          <mat-option [value]="2">Others</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="xrayImpression == 2">
        <mat-label>Others</mat-label>
        <input
          matInput
          placeholder="Input"
          [formControl]="xrayImpressionOthers"
        />
      </mat-form-field>
      <mat-form-field appearance="fill" *ngIf="selectedValue == 2">
        <mat-label>Remarks</mat-label>
        <mat-select [(ngModel)]="xrayRemarks">
          <mat-option [value]="1">Normal</mat-option>
          <mat-option [value]="2">Others</mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="xrayRemarks == 1">
        <p style="border: 1px solid grey; border-radius: 10px; padding: 10px">
          No active lung opacities. <br />
          Heart is normal in size and configuration. <br />
          Pulmonary vascular markings are within normal. <br />
          Both hemidiaphragms and costophrenic sulci are intact. <br />
          Intact bones
        </p>
      </div>
      <mat-form-field appearance="fill" *ngIf="xrayRemarks == 2">
        <mat-label>Others</mat-label>
        <input matInput placeholder="Input" [formControl]="xrayRemarksOthers" />
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="selectedValue == 3">
      <mat-form-field appearance="fill">
        <mat-label>Findings</mat-label>
        <mat-select [(ngModel)]="rprFindings">
          <mat-option [value]="1">Non-Reactive</mat-option>
          <mat-option [value]="2">Reactive</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="fill">
        <mat-label>Remarks</mat-label>
        <input matInput placeholder="Input" [formControl]="rprRemarks" />
      </mat-form-field>
    </ng-container>
  </div>

  <div *ngIf="selectedValue == 1" class="d-flex justify-content-between">
    <button
      class="text-right mt-3"
      mat-raised-button
      color="secondary"
      (click)="handleChso(2)"
      [disabled]="isLoading"
    >
      Fail
    </button>
    <button
      class="text-right mt-3"
      mat-raised-button
      color="primary"
      style="color: white"
      (click)="handleChso(1)"
      [disabled]="isLoading"
    >
      Pass
    </button>
  </div>

  <mat-form-field appearance="fill" *ngIf="!data.isHsoEvaluator && selectedValue == 3">
    <mat-label>Remarks</mat-label>
    <mat-select [(ngModel)]="rprFindings">
      <mat-option [value]="1">Non-Reactive</mat-option>
      <mat-option [value]="2">Reactive</mat-option>
    </mat-select>
  </mat-form-field>

  <div *ngIf="!data.isHsoEvaluator || selectedValue == 2 || selectedValue == 3">
    <ngx-dropzone
      (change)="onSelect($event)"
      [multiple]="false"
      accept="image/*,application/pdf"
      class="mt-3"
    >
      <ngx-dropzone-label
        >Click here to upload laboratory files!
      </ngx-dropzone-label>
      <ngx-dropzone-preview
        *ngFor="let f of files"
        [removable]="true"
        (removed)="onRemove(f)"
      >
        <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
      </ngx-dropzone-preview>
    </ngx-dropzone>
    <button
      class="text-right mt-3"
      mat-raised-button
      color="primary"
      (click)="handleSubmit()"
      [disabled]="isLoading"
    >
      {{ isLoading ? "Uploading..." : "Submit" }}
    </button>
  </div>

  <ng-container *ngIf="isLoading">
    <div>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
  </ng-container>
</div>
